import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ns = 'likeablelocal/audienceBehaviors';
var CATEGORY_SEARCH = "".concat(ns, "/CATEGORY_SEARCH");
var CATEGORY_SEARCH_SUCCESS = "".concat(ns, "/CATEGORY_SEARCH_SUCCESS");
var CATEGORY_SEARCH_FAIL = "".concat(ns, "/CATEGORY_SEARCH_FAIL");
var initialState = {
  searching: false
};
export default function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CATEGORY_SEARCH:
      return _objectSpread(_objectSpread({}, state), {}, {
        searching: true
      });

    case CATEGORY_SEARCH_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        searching: false
      });

    case CATEGORY_SEARCH_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        searching: false
      });

    default:
      return state;
  }
}
export function categorySearch(category) {
  var url = "/facebook/ad/categorySearch?category=".concat(category);
  return {
    types: [CATEGORY_SEARCH, CATEGORY_SEARCH_SUCCESS, CATEGORY_SEARCH_FAIL],
    promise: function promise(client) {
      return client.get(url);
    }
  };
}